import { RiskAssessmentResultControlType as Risk_Assessment_Result_Control_Type_Enum } from '@risksmart-app/domain/src/types/consts/risk-assessment-result-control-type';
import type { Ref } from 'react';

import type { WidgetRef } from '../../types';
import { EnterpriseRiskHeatmap } from './EnterpriseRiskHeatmap';

export const ResidualEnterpriseRiskHeatmap = (
  _props: unknown,
  ref: Ref<WidgetRef>
) => {
  return (
    <EnterpriseRiskHeatmap
      ref={ref}
      controlType={Risk_Assessment_Result_Control_Type_Enum.Controlled}
    />
  );
};
